import { api } from './config';
import { AxiosResponse } from 'axios';
import { 
  LoginRequest, 
  LoginResponse,
  User,
  CreateUser,
  UpdateUser,
  ChangePassword,
  ResetPassword
} from '../../types/auth';

export const authApi = {
  login: (data: LoginRequest): Promise<AxiosResponse<LoginResponse>> =>
    api.post('/users/login', data),
    
  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
  
  logout: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },
  
  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('token');
  },
  
  hasRole: (role: string): boolean => {
    const user = authApi.getCurrentUser();
    return user?.roles.includes(role) || false;
  }
};

// Users API
export const usersApi = {
  getAll: (): Promise<AxiosResponse<User[]>> =>
    api.get('/users'),
    
  getById: (id: string): Promise<AxiosResponse<User>> =>
    api.get(`/users/${id}`),
    
  create: (data: CreateUser): Promise<AxiosResponse<User>> =>
    api.post('/users', data),
    
  update: (id: string, data: UpdateUser): Promise<AxiosResponse<User>> =>
    api.put(`/users/${id}`, data),
    
  delete: (id: string): Promise<AxiosResponse<void>> =>
    api.delete(`/users/${id}`),
    
  changePassword: (id: string, data: ChangePassword): Promise<AxiosResponse<string>> =>
    api.post(`/users/${id}/change-password`, data),
    
  resetPassword: (id: string, data: ResetPassword): Promise<AxiosResponse<string>> =>
    api.post(`/users/${id}/reset-password`, data)
};
